module.exports = __webpack_public_path__ + "static/media/comment.337017e8.svg";